// SOURCE (copied-thin, 199592): network-coverage-map/NetworkCoverageMapsConstants.ts.
// ZIP-owned; CONSOLIDATION (199592): move to a shared map-rendering module.

export const ZIP_LABEL_SOURCE_ID = "zip-coverage-label-source";
export const ZIP_BOUNDARY_LABEL_LAYER_ID = "zip-coverage-boundary-label-layer";
export const ZIP_FOCUSED_BOUNDARY_SOURCE_ID = "zip-coverage-focused-boundary-source";
export const ZIP_FOCUSED_BOUNDARY_LAYER_ID = "zip-coverage-focused-boundary-layer";
export const ZIP_BOUNDARY_COLOR = "#8B00FF"; // = county MARKET_PROVIDER_COLOR, for a consistent look
export const ZIP_BOUNDARY_MIN_ZOOM_LEVEL = 8;

export const COUNTY_BOUNDARY_SOURCE_ID = "zip-coverage-county-boundary-source";
export const COUNTY_BOUNDARY_LAYER_ID = "zip-coverage-county-boundary-layer";
export const COUNTY_BOUNDARY_LABEL_LAYER_ID = "zip-coverage-county-boundary-label-layer";
export const COUNTY_BOUNDARY_COLOR = "#404142"; // = county's ZIP_CODE_BORDER_COLOR, kept distinct from ZIP_BOUNDARY_COLOR

export const VIEW_PADDING = 50;

/** Must track `$left-panel-width` in styles/maps/_zip-coverage-map.scss. */
export const LEFT_PANEL_VIEW_PADDING = 380;

/**
 * Ceiling for fit-to-bounds zoom (202310): a zero-area extent otherwise makes Mapbox zoom all the way in.
 * 13 keeps a single zip comfortably in frame, and stays above ZIP_BOUNDARY_MIN_ZOOM_LEVEL so labels show.
 */
export const MAX_FIT_ZOOM_LEVEL = 13;

export const COUNTY_MIN_ZOOM_LEVEL = 8;

// Provider Contribution Measures sliders (0–100). ZIP-local copies of county's constants.
export const ZERO_PERCENT_FILTER = 0;
export const HUNDRED_PERCENT_FILTER = 100;
export const DEFAULT_CONTRIBUTION_RANGE: [number, number] = [ZERO_PERCENT_FILTER, HUNDRED_PERCENT_FILTER];

// Members
export const MEMBERS_WITH_ACCESS_COLOR = "#008559";
export const MEMBERS_WITHOUT_ACCESS_COLOR = "#CC3A52";
export const MEMBER_SOURCE_ID = "zip-coverage-member-source";
export const MEMBER_LAYER_ID = "zip-coverage-member-layer";
export const MEMBERS_IMAGE_ID = "zip-coverage-members-image";

// Providers (202310). Copied from county's NetworkCoverageMapsConstants — AC 2 requires the pins match, so
// these must not drift. Two collide with the boundary colours above (Market == zip outline, Terminated ==
// county line); accepted, since county parity wins.
export const NETWORK_PROVIDER_COLOR = "#056edf"; // = county NETWORK_PROVIDER_COLOR
export const PROSPECT_PROVIDER_COLOR = "#FF5500"; // = county PROSPECT_PROVIDER_COLOR
export const MARKET_PROVIDER_COLOR = "#8B00FF"; // = county MARKET_PROVIDER_COLOR
export const TARGET_PROVIDER_COLOR = "#FF00FF"; // = county TARGET_PROVIDER_COLOR
export const TERMINATED_PROVIDER_COLOR = "#32323C"; // = county TERMINATED_PROVIDER_COLOR
export const EXCLUDED_PROVIDER_COLOR = "#ADE8F4"; // = county EXCLUDED_PROVIDER_COLOR

// Name of the SVG icon defined in Mapbox Studio. Both styles the layer control offers must include it, or no
// pins render and nothing errors.
export const PROVIDER_ICON_IMAGE_ID = "Providers";

export const PROVIDERS_SOURCE_ID = "zip-coverage-providers-source";
export const PROVIDERS_LAYER_ID = "zip-coverage-providers-layer";

export const PROVIDER_ICON_UNSELECTED_MIN_SIZE = 0.25;
export const PROVIDER_ICON_UNSELECTED_MAX_SIZE = 0.3;

export const PROVIDER_ICON_SELECTED_SIZE = 0.5;
export const PROVIDER_ICON_SHADOW_COLOR = "rgba(50, 50, 60, 0.5)";
export const SELECTED_PROVIDER_SOURCE_ID = "zip-coverage-selected-provider-source";
export const PROVIDER_HIGHLIGHTED_LAYER_ID = "zip-coverage-provider-highlighted-layer";

// Map Details Bar

/** Shown for any null/unavailable metric ("---"). */
export const NOT_AVAILABLE_PLACEHOLDER = "---";

/** Provider Listing Panel **/
export const DEFAULT_PROVIDER_PAGE_SIZE = 50;
export const PROVIDER_PAGE_SIZE_OPTIONS: number[] = [25, 50, 100];
